// frontend/client/src/App.js
import { Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "./auth";

import LoadingScreen from "./LoadingScreen";

import LoginPage from "./LoginPage";
import HomePage from "./HomePage";
import DashboardPage from "./DashboardPage";
import CampusFeedPage from "./CampusFeedPage";
import ProfilePage from "./ProfilePage";
import AnonymousFeedPage from "./AnonymousFeedPage";
import FeedsReactPage from "./FeedsReactPage";
import FriendsFeedPage from "./FriendsFeedPage";
import SocialPage from "./SocialPage";
import ConnectionsPage from "./ConnectionsPage";
import UserProfilePage from "./UserProfilePage";

function PrivateRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return <LoadingScreen label="LOADING" />;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
}

function App() {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/login" element={<LoginPage />} />

      <Route path="/reset-password" element={<LoginPage />} />

      {/* Protected routes */}
      <Route
        path="/dashboard"
        element={
          <PrivateRoute>
            <HomePage />
          </PrivateRoute>
        }
      />

      <Route
        path="/connections"
        element={
          <PrivateRoute>
            <ConnectionsPage />
          </PrivateRoute>
        }
      />
      
      <Route
        path="/social"
        element={
          <PrivateRoute>
            <SocialPage />
          </PrivateRoute>
        }
      />

      <Route
        path="/friends-feed"
        element={
          <PrivateRoute>
            <FriendsFeedPage />
          </PrivateRoute>
        }
      />

      <Route
        path="/campus-feed"
        element={
          <PrivateRoute>
            <CampusFeedPage />
          </PrivateRoute>
        }
      />

      <Route
        path="/anonymous-feed"
        element={
          <PrivateRoute>
            <AnonymousFeedPage />
          </PrivateRoute>
        }
      />

      <Route
        path="/profile"
        element={
          <PrivateRoute>
            <ProfilePage />
          </PrivateRoute>
        }
      />

      <Route
        path="/user-profile"
        element={
          <PrivateRoute>
            <UserProfilePage />
          </PrivateRoute>
        }
      />

      <Route
        path="/feeds-react"
        element={
          <PrivateRoute>
            <FeedsReactPage />
          </PrivateRoute>
        }
      />

      {/* bilinmeyen route → dashboard'a yönlendir */}
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

export default App;
